export const STORAGE_KEYS = {
  DRAFT: 'SCB_DRAFT',
  PREFILL: 'SIGNUP_PREFILL',
  ORIGIN: 'SIGNUP_ORIGIN',
};

export const loadJson = key => {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveJson = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {}
};

export const removeKey = key => {
  try {
    sessionStorage.removeItem(key);
  } catch {}
};

/**
 * Backward compatible helpers (if any other files use these names)
 */
export const loadDraft = () => loadJson(STORAGE_KEYS.DRAFT);
export const saveDraft = draft => saveJson(STORAGE_KEYS.DRAFT, draft);
export const clearDraft = () => removeKey(STORAGE_KEYS.DRAFT);
